import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { createUrl } from '../helpers/router_helper';

export const useRouter = (routerOptions = {}) => {
  const navigate = useNavigate();

  const location = useLocation();
  const { search } = location;

  const { keepQueryParams = false } = routerOptions;

  const goTo = useCallback(
    (route, params, options = {}) => {
      if (keepQueryParams) {
        options.queryParams = search;
      }

      const url = createUrl(route, params, options);
      navigate(url);
    },
    [search, navigate, keepQueryParams],
  );

  return {
    goTo,
    location,
    navigate,
  };
};
